import RolloutSampleFailureDTO from './RolloutSampleFailureDTO';
import RolloutStatusCounts from './RolloutStatusCounts';

export default class RolloutStudioSummaryDTO {

    public studioId: number;
    public studioName: string;
    public firmwareRevisionId?: number;
    public counts: RolloutStatusCounts;
    public failures: RolloutSampleFailureDTO[] = [];

    constructor(data: { [key: string]: any }) {
        this.studioId = data['studioId'];
        this.studioName = data['studioName'];
        this.firmwareRevisionId = data['firmwareRevisionId'];
        this.counts = new RolloutStatusCounts(data['counts'] ?? {});
        this.failures = Array.isArray(data['failures']) ? data['failures']
            .map((failure: any) => new RolloutSampleFailureDTO(failure)) : [];
    }
}
